import { useMemo } from 'react'
import styles from './SubHeaders.module.css'
import useEvaluateSaveEnabled from '../../../customHooks/useEvaluateSaveEnabled'
import { Spinner, Tooltip } from '@fluentui/react-components'
import {
  ArchiveRegular,
  EditRegular,
  EyeRegular,
  GlassesRegular,
  LockClosedRegular,
} from '@fluentui/react-icons'
import SaveProjectEconomy from '../../SaveProjectEconomy/SaveProjectEconomy'
import { useProjectInfo } from '../../../fetchData/queries/useProjectInfo'
import { useEditingContext } from '../../../context/EditingContext'
import Snapshots from '../../Snapshots/Snapshots'
import { useInteractionContext } from '../../../context/InteractionContext'
import { EasterEggButton } from '../../EasterEgg/EasterEggButton'

const ProjectEconomySubHeader = () => {
  const { easterEggMode } = useEditingContext()

  const { data: projectInfo, isLoading: projectInfoLoading } = useProjectInfo()
  const projectIdNr = projectInfo?.identificationNumber?.toString()
  const projectName = projectInfo?.name
  const workOrder = projectInfo?.workOrder
  const isFinalized = projectInfo?.isFinalized
  const isArchived = projectInfo?.isArchived

  const { editingEnabled, readOnlyMode, snapshotMode } = useEditingContext()
  const { refreshLoading } = useInteractionContext()

  const projectHeader: string =
    projectName && projectIdNr
      ? `${projectName} - ${projectIdNr}`
      : 'Prognosuppföljning'
  document.title = projectHeader

  const edited: boolean = useEvaluateSaveEnabled()

  const projectEconomyMode = useMemo((): {
    text: string
    icon: JSX.Element
  } => {
    if (easterEggMode) {
      return {
        text: 'Projektekonomi i lätt att läsa läge - ändringar kan sparas',
        icon: <GlassesRegular />,
      }
    }

    if (isArchived) {
      return {
        text: 'Projekt arkiverat - ändringar kan ej sparas',
        icon: <ArchiveRegular />,
      }
    } else if (isFinalized) {
      return {
        text: 'Projekt slutredovisat - ändringar kan ej sparas',
        icon: <LockClosedRegular />,
      }
    } else if (editingEnabled && !readOnlyMode && !snapshotMode) {
      return {
        text: 'Projektekonomi i redigeringsläge - ändringar kan sparas',
        icon: <EditRegular />,
      }
    } else {
      return {
        text: 'Projektekonomi i läsläge - ändringar kan ej göras',
        icon: <EyeRegular />,
      }
    }
  }, [
    easterEggMode,
    isArchived,
    isFinalized,
    editingEnabled,
    readOnlyMode,
    snapshotMode,
  ])

  const systemInteractionStatus = () => {
    if (projectInfoLoading || refreshLoading) {
      return <Spinner style={{ margin: '8px' }} size="small" />
    }

    return (
      <div
        style={{
          margin: '8px',
          cursor: 'default',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {projectEconomyMode.icon}
      </div>
    )
  }

  const tooltipHeader = () => (
    <div className={`${styles.flexContainer} ${styles.flexStart}`}>
      {projectHeader && projectEconomyMode && (
        <Tooltip content={projectEconomyMode.text} relationship="description">
          <div className={styles.childFlexContainer}>
            <h4 className={styles.subHeader}>{projectHeader}</h4>
            <h4 className={styles.subHeader}>(AO: {workOrder})</h4>
            {systemInteractionStatus()}
          </div>
        </Tooltip>
      )}
    </div>
  )

  return (
    <div className={styles.subBanner}>
      <EasterEggButton buttonContent={tooltipHeader()} clickLimit={5} />

      <div className={`${styles.flexContainer} ${styles.flexEnd}`}>
        <Snapshots edited={edited} />
        <SaveProjectEconomy edited={edited} />
      </div>
    </div>
  )
}

export default ProjectEconomySubHeader
